import { useSelector } from 'react-redux';

export const useLocalString = () => {
  const localization = useSelector(state => state.localization);

  return (component, type = null, name = null, section = null) => {
    let string = '';
    if (localization?.common) {
      let componentPart = localization[component];
      component !== 'common' &&
        localization.components?.[component] &&
        (componentPart = localization.components[component]);
      string = componentPart[type];
      name && componentPart[type]?.[name] && (string = componentPart[type][name]);
      section && (string = componentPart.sections[section][name]);
      section && type && (string = componentPart.sections[section][type][name]);
    }
    return string;
  };
};
export const useTranslation = () => {
  const translations = useSelector(state => state.localization);

  const t = (...path) => {
    const searchPaths = [];

    if (!['components', 'common', 'instances'].includes(path[0])) {
      searchPaths.push(['components', ...path], ['common', ...path]);
    } else {
      searchPaths.push(path);
    }

    for (const tryPath of searchPaths) {
      let current = translations;
      let found = true;

      for (const part of tryPath) {
        if (current && current[part] !== undefined) {
          current = current[part];
        } else {
          found = false;
          break;
        }
      }

      if (found) {
        return current;
      }
    }

    //console.warn(`Translation not found for path: ${path.join('.')}`);
    return `[${path.join('.')}]`;
  };

  return t;
};
